import React, {FC, useCallback, useState, useEffect} from "react";
import { useTask } from '../stateManagement/context';

import {
    ComponentTypeID,
    IAdequacy,
    IControlMeasure, IControlMeasureAssessment,
    IControlMeasureFailureMode,
    IControlType, IHarm,
    IProjectFailureMode
} from "../types/types";

import {Checkbox, TableCell, TableHead, TableRow, TextField} from "@material-ui/core";
import FailureModesControlMeasureSelect from "./failure_mode_control_measure";
import ControlTypeSelection from "./control_type";
import AdequacySelection from "./adequacy_selection";
import Comments from "./comments";



interface IControlMeasureAssessmentProps {
    control_measure: IControlMeasure
    failure_mode: IProjectFailureMode
    control_types: IControlType[]
    adequacies: IAdequacy[]
    control_measure_assessment: IControlMeasureAssessment
    // updateFailureModeControlMeasures: (failureModeControlMeasures: IControlMeasureFailureMode) => void;
    updateControlMeasuresAssessment: (controlMeasureAssessment: IControlMeasureAssessment) => void;
}



const AdditionalControlMeasureAssessment: FC<IControlMeasureAssessmentProps> = ({control_measure,
                                                                          control_types,
                                                                          failure_mode,
                                                                          control_measure_assessment,
                                                                          adequacies,
                                                                          updateControlMeasuresAssessment
                                                      // updateFailureModeControlMeasures,

}) => {

    const [justification, setJustification] = useState<string>(control_measure_assessment.justification as string);
    const [deMinimis, setDeMinimis] = useState<boolean>(control_measure_assessment.de_minimis as boolean);
    const [goodPractice, setGoodPractice] = useState<boolean>(control_measure_assessment.good_practice as boolean);
    const [practicable, setPracticable] = useState<boolean>(control_measure_assessment.practicable as boolean);
    const [effective, setEffective] = useState<boolean>(control_measure_assessment.effective as boolean);
    const [considered, setConsidered] = useState<boolean>(control_measure_assessment.considered as boolean);
    const [write_access, setWriteAccess] = useState<boolean>(false);

    let tasks = useTask()

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])

    const updateAdequacies= useCallback((selected_id: number) => {
        control_measure_assessment.adequacy_id = selected_id;
        // Object.keys(control_measure_assessment).forEach(
        //     (key: number | string) => (control_measure_assessment[key] == null) && delete control_measure_assessment[key]);


        updateControlMeasuresAssessment(control_measure_assessment)

    }, [updateControlMeasuresAssessment]);




    return (
        <TableRow>
            {/*<TableCell>{failure_mode.failure_mode?.name}</TableCell>*/}
            <TableCell>{control_measure.description}</TableCell>
            <TableCell>{control_types.find( ct => ct.id === control_measure.control_type_id)?.name}</TableCell>
            <TableCell>
                <TextField
                    style ={{width: '100%'}}
                    inputProps={{ style: { fontSize: "11pt" } }}
                    multiline={true}
                id="standard-text"
                value={justification}
                InputLabelProps={{
                    shrink: true,
                }}
                disabled={!write_access}
                onChange={(event) => {
                    let value = event.target.value

                    if (value) {
                        setJustification(value)
                        control_measure_assessment.justification = value
                        updateControlMeasuresAssessment(control_measure_assessment)
                    }
                }
                }

            />
            </TableCell>
            <TableCell>
                <Checkbox
                    checked={deMinimis}
                    disabled={!write_access}
                    color="primary"
                    onChange={() => {
                        control_measure_assessment.de_minimis = !deMinimis
                        updateControlMeasuresAssessment(control_measure_assessment)
                        setDeMinimis(!deMinimis)
                    }}
                />
            </TableCell>
            <TableCell>
                <Checkbox
                    disabled={!write_access}
                    checked={goodPractice}
                    color="primary"
                    onChange={() => {
                        control_measure_assessment.good_practice = !goodPractice
                        updateControlMeasuresAssessment(control_measure_assessment)
                        setGoodPractice(!goodPractice)
                    }}
                />
            </TableCell>
            <TableCell>
                <Checkbox
                    disabled={!write_access}
                    checked={practicable}
                    color="primary"
                    onChange={() => {
                        control_measure_assessment.practicable = !practicable
                        updateControlMeasuresAssessment(control_measure_assessment)
                        setPracticable(!practicable)
                    }}
                />
            </TableCell>
            <TableCell>
                <Checkbox
                    disabled={!write_access}
                    checked={effective}
                    color="primary"
                    onChange={() => {
                        control_measure_assessment.effective = !effective
                        updateControlMeasuresAssessment(control_measure_assessment)
                        setEffective(!effective)
                    }}
                />
            </TableCell>
            <TableCell>
                <Checkbox
                    disabled={!write_access}
                    checked={considered}
                    color="primary"
                    onChange={() => {
                        control_measure_assessment.considered = !considered
                        updateControlMeasuresAssessment(control_measure_assessment)
                        setConsidered(!considered)
                    }}
                />
            </TableCell>
            <TableCell>{control_measure.uuid && <Comments parent_uuid={parseInt(""+ failure_mode.id + control_measure.uuid)} type_id={ComponentTypeID.ControlMeasureAssessment}/>}</TableCell>

        </TableRow>
    );
}

export default AdditionalControlMeasureAssessment;
